import { render, staticRenderFns } from "./circle-reply.vue?vue&type=template&id=2dcbe36e&scoped=true&"
import script from "./circle-reply.vue?vue&type=script&lang=js&"
export * from "./circle-reply.vue?vue&type=script&lang=js&"
import style0 from "./circle-reply.vue?vue&type=style&index=0&id=2dcbe36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbe36e",
  null
  
)

export default component.exports